import React from "react";
import { Routes, Route } from "react-router-dom";
import Nav from "./components/Nav";
import Login from "./pages/Login";
import Home from "./pages/Home";
import TodayLesson from "./pages/TodayLesson";
import Archive from "./pages/Archive";
import Search from "./pages/Search";

// Reading lesson content is public by design (2026-09-20) - no ProtectedRoute
// wrapping here. /login still exists for admin session use only.
export default function App() {
  return (
    <>
      <Nav />
      <main>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Home />} />
          <Route path="/today" element={<TodayLesson />} />
          <Route path="/archive" element={<Archive />} />
          <Route path="/search" element={<Search />} />
        </Routes>
      </main>
    </>
  );
}
